export default "__VITE_ASSET__DLSxZhZp__"